import React, { FC } from "react";
import { CssBaseline, CssBaselineProps } from "@mui/material"

const CssBaselineWrapper: FC<CssBaselineProps> = ({...props}) => <CssBaseline {...props}/>

export default CssBaselineWrapper;
